import Vue from 'vue'
import master from '../masterModules/masterMutation.js'
// master-action
const URL = process.env.API_URL
const header = master.state.header

export default {
  async setNotifications(store, payload) {
    store.state.notificationsList = []
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        pageNo: payload.pageNo,
        count: 20
      }
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/notification/list',
      data,
      config
    )

    // 成功後の処理
    store.commit('setNotifications', response)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/notificationsModules/actions.js